// Country flag — renders the region's flag from the country-flag-icons CDN
// (the same source the legacy economic-calendar table uses), falling back to a
// neutral placeholder when the region has no matching flag.

import { useState } from "react";

interface FlagProps {
  region: string | null | undefined;
}

/** UK is the common alias for the GB flag code. */
const CODE_MAPPINGS: Record<string, string> = {
  UK: "GB",
  EU: "EU",
};

const FLAG_BASE =
  "https://purecatamphetamine.github.io/country-flag-icons/3x2";

export function Flag({ region }: FlagProps) {
  const code = (region || "").toUpperCase();
  const resolved = CODE_MAPPINGS[code] || code;
  const [failed, setFailed] = useState(false);

  if (!resolved || failed) {
    return (
      <span className="flag-wrapper" title={code || "Unknown"}>
        <span className="flag-icon flag-placeholder-icon" aria-hidden="true" />
      </span>
    );
  }

  return (
    <span className="flag-wrapper" title={code}>
      <img
        className="flag-icon"
        src={`${FLAG_BASE}/${resolved}.svg`}
        alt={`${code} flag`}
        loading="lazy"
        onError={() => setFailed(true)}
      />
    </span>
  );
}

export default Flag;
